export enum DatasheetElementAlignment {
  left = "left",
  right = "right",
  top = "top",
  bottom = "bottom",
}

export enum DatasheetElementSizeAlignment {
  vertical = "vertical",
  horizontal = "horizontal",
}